import { makeInflect } from "../../../../core/utils/makeInflect.js";

export const inflectLabel = makeInflect("cedulka", "cedulky", "cedulek");
